import React from 'react';
import './service.css';
import { FaLaptopCode, FaMobileAlt, FaPaintBrush, FaDesktop, FaCloud, FaRobot, FaDatabase, FaBullhorn } from 'react-icons/fa';
import { Link } from 'react-router-dom';
import ThreeScene from '../profile/threescene';

const services = [
    { name: 'Web Development', icon: <FaLaptopCode />, path: '/web-development' },
    { name: 'App Development', icon: <FaMobileAlt />, path: '/app-development' },
    { name: 'UI/UX Design', icon: <FaPaintBrush />, path: '/ui-ux-design' },
    { name: 'Desktop Application Development', icon: <FaDesktop />, path: '/desktop-application-development' },
    { name: 'Cloud Integration & Dev Ops', icon: <FaCloud />, path: '/cloud-integration-dev-ops' },
    { name: 'Machine Learning and AI Solutions', icon: <FaRobot />, path: '/machine-learning-ai-solutions' },
    { name: 'Database Management & Integration', icon: <FaDatabase />, path: '/database-management-integration' },
    { name: 'Digital Marketing Solutions', icon: <FaBullhorn />, path: '/digital-marketing-solutions' },
  ];

const Services = () => {
  return (
    <div className="services-wrapper">
      <ThreeScene/>
      <h2>Our Services</h2>
      <div className="services-container">
        {services.map((service, index) => (
         <Link to={service.path} className="service-card" key={index}>
            <div className="service-icon">{service.icon}</div>
            <div className="service-name">{service.name}</div>
            </Link>
        ))}
      </div>
    </div>
  );
};

export default Services;
